[
  {
    "minLevel": 1,
    "maxLevel": 19,
    "requirement": 120,
    "rewardGems": 200
  },
  {
    "minLevel": 20,
    "maxLevel": 49,
    "requirement": 200,
    "rewardGems": 200
  },
  {
    "minLevel": 50,
    "maxLevel": 99,
    "requirement": 280,
    "rewardGems": 200
  },
  {
    "minLevel": 100,
    "requirement": 360,
    "rewardGems": 200
  }
]
